<template>
	<my-dialog :visible.sync="showDialog" title="修改会员卡号" dialog-type="form" :close-on-click-modal="false" width="500px" @close="closeDialog">
		<div class="change-cardno-content">
			<el-form :model="formData" label-width="100px" size="small" class="change-cardno-form">
				<el-form-item label="会员名称">
					<span>{{ formData.customerName }}</span>
				</el-form-item>
				<el-form-item label="原卡号">
					<span style="color: #909399">{{ formData.oldVipNo }}</span>
				</el-form-item>
				<el-form-item label="新卡号" required>
					<el-input v-model="formData.newVipNo" placeholder="请输入新会员卡号" clearable maxlength="50"></el-input>
				</el-form-item>
				<el-form-item label="修改原因">
					<el-input v-model="formData.remark" type="textarea" :rows="3" placeholder="请输入修改原因（选填）" maxlength="200" show-word-limit></el-input>
				</el-form-item>
			</el-form>
		</div>
		<template #footer>
			<div class="dialog-footer">
				<el-button size="small" @click="closeDialog">取消</el-button>
				<el-button type="primary" size="small" :loading="isSubmitting" @click="handleSubmit">确认修改</el-button>
			</div>
		</template>
	</my-dialog>
</template>
<script>
import { UpdateVipCardNo } from "@/api/vipApi.js";
export default {
	props: [],
	data() {
		return {
			showDialog: false,
			isSubmitting: false,
			formData: {
				keyId: "",
				customerName: "",
				oldVipNo: "",
				newVipNo: "",
				remark: ""
			}
		};
	},
	components: {},
	created() {},
	methods: {
		// 打开弹窗
		getChangeDialog(row) {
			this.formData = {
				keyId: row.keyId,
				customerName: row.customerInfo ? row.customerInfo.name : "",
				oldVipNo: row.vipNo,
				newVipNo: "",
				remark: ""
			};
			this.showDialog = true;
		},
		// 关闭
		closeDialog() {
			this.showDialog = false;
		},
		// 确认修改
		handleSubmit() {
			if (!this.formData.newVipNo || !this.formData.newVipNo.trim()) {
				this.$message.error("请输入新会员卡号！");
				return;
			}
			if (this.formData.newVipNo.trim() == this.formData.oldVipNo) {
				this.$message.error("新会员卡号与原会员卡号一致，无需修改！");
				return;
			}
			this.$confirm("确认修改该会员的会员卡号吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					this.isSubmitting = true;
					UpdateVipCardNo({
						keyId: this.formData.keyId,
						newVipNo: this.formData.newVipNo.trim(),
						remark: this.formData.remark
					})
						.then((res) => {
							if (res.code == 1) {
								this.$message({
									type: "success",
									message: "会员卡号修改成功！"
								});
								this.showDialog = false;
								this.$emit("success");
							} else {
								this.$message.error(res.msg);
							}
						})
						.catch((err) => {
							this.$message.error("会员卡号修改失败，请稍后再试！");
						})
						.finally(() => {
							this.isSubmitting = false;
						});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消修改"
					});
				});
		}
	}
};
</script>
<style scoped lang="scss">
.change-cardno-content {
	width: 100%;
	padding: 10px 20px 0 0;
}

.change-cardno-form {
	.el-form-item {
		margin-bottom: 18px;
	}
}

.dialog-footer {
	display: flex;
	justify-content: flex-end;
	gap: 8px;
}
</style>
